(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
      this.abortController = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();

      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      const { signal } = this.abortController;

      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e), { signal });

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText(), { signal });
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus(), { signal });
      this.select.addEventListener('blur', () => this.handleBlur(), { signal });
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || this.dataset.defaultLabel || '';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this._submitInFlight) return;
      this._submitInFlight = true;

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      let cartBeforeSubmission = null;
      let cartBeforePromise = null;
      let config;
      let formData;
      const getCartBeforeSubmission = async () => {
        if (!cartBeforePromise) {
          cartBeforePromise = this.fetchCartState().then((cart) => {
            cartBeforeSubmission = cart;
            return cart;
          }).catch((error) => {
            window.__steedReportError && window.__steedReportError('product-form:cart-before', error);
            cartBeforeSubmission = null;
            return null;
          });
        }

        return cartBeforePromise;
      };

      let nativeRequestPromise = null;
      const submitNativelyOnce = () => {
        if (!nativeRequestPromise) {
          // The claimant receives an abortable config. Native fallback must use
          // a fresh config after that claim is cancelled, otherwise it inherits
          // the aborted signal and can never recover the add.
          const nativeConfig = {
            method: config.method,
            headers: config.headers,
            body: config.body,
          };
          nativeRequestPromise = fetch(`${window.Shopify.routes.root}cart/add.js`, nativeConfig)
            .then(async (response) => {
              const responseData = await response.json();
              if (!response.ok) {
                throw responseData;
              }
              return responseData;
            });
        }

        return nativeRequestPromise;
      };

      const recoverClaimedRequest = async (subscriberError) => {
        window.__steedReportError && window.__steedReportError(
          'product-form:cart-request-fallback',
          subscriberError,
          { severity: 'warning' }
        );

        // Timeout aborts the claimant first. Yield one short task so a
        // signal-compliant in-flight fetch can reject before we inspect cart
        // state and decide whether native fallback is still needed.
        if (subscriberError && subscriberError.code === 'CART_REQUEST_TIMEOUT') {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }

        let cartAfterClaim = null;
        try {
          cartAfterClaim = await this.fetchCartState();
        } catch (cartError) {
          window.__steedReportError && window.__steedReportError('product-form:cart-fallback-check', cartError);
        }

        if (this.hasRequestedCartDelta(cartBeforeSubmission, cartAfterClaim, formData)) {
          return {
            cart: cartAfterClaim,
            response: this.findRequestedCartItem(cartAfterClaim, formData),
          };
        }

        return {
          cart: null,
          response: await submitNativelyOnce(),
        };
      };

      try {
        config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        };

        formData = new FormData(this.form);

        // Dispatch event allowing subscribers to modify formData
        this.dispatchEvent(
          new CustomEvent('product-form:submit:before', {
            bubbles: true,
            detail: {
              form: formData,
            },
            cancelable: true
          })
        );

        // Wait for the next tick to allow async event listeners to complete
        // This ensures all synchronous and microtask listeners have finished
        await new Promise(resolve => {
          // Use queueMicrotask for better performance than setTimeout
          queueMicrotask(resolve);
        });

        config.body = formData;

        // A pre-dispatch snapshot lets a rejected/timed-out subscriber fall
        // back without double-adding an item it already placed in the cart.
        await getCartBeforeSubmission();

        // Install the deferred before dispatch so a synchronous subscriber can
        // settle the request from inside its event handler.
        const cartRequestAbortController = new AbortController();
        config.signal = cartRequestAbortController.signal;
        const cartResponsePromise = this.waitForCartResponse(cartRequestAbortController);

        // Dispatch event allowing subscribers to handle cart request themselves
        const cartRequestEvent = new CustomEvent('product-form:cart:request', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            config: config,
            cartBefore: cartBeforeSubmission,
            getCartBefore: getCartBeforeSubmission,
            signal: cartRequestAbortController.signal,
            resolve: (responseData) => this.resolveCartRequest(responseData),
            reject: (error) => this.rejectCartRequest(error)
          }
        });

        const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
        let responseData;
        let recoveredCart = null;

        if (cartRequestHandled) {
          try {
            responseData = await cartResponsePromise;
          } catch (subscriberError) {
            const recovery = await recoverClaimedRequest(subscriberError);
            responseData = recovery.response;
            recoveredCart = recovery.cart;
          }
        } else {
          this.cancelCartRequest();
          responseData = await submitNativelyOnce();
        }

        // Get updated cart state after form submission
        const cartAfterSubmission = recoveredCart || await this.fetchCartState();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
        window.__steedReportError && window.__steedReportError('product-form:submit', error, { severity: 'error' });
      } finally {
        this.cancelCartRequest();
        this._submitInFlight = false;
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse(abortController) {
      this.cancelCartRequest();

      let resolvePromise;
      let rejectPromise;
      const promise = new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
      });

      const resolver = {
        promise,
        resolve: resolvePromise,
        reject: rejectPromise,
        settled: false,
        timeout: null,
        abortController,
      };

      this._cartRequestResolver = resolver;
      resolver.timeout = setTimeout(() => {
        const timeoutError = new Error('Cart request timeout - no response received from subscriber');
        timeoutError.code = 'CART_REQUEST_TIMEOUT';
        this.settleCartRequest('reject', timeoutError);
      }, 30000);

      return promise;
    }

    settleCartRequest(type, value) {
      const resolver = this._cartRequestResolver;
      if (!resolver || resolver.settled) return false;

      resolver.settled = true;
      clearTimeout(resolver.timeout);
      delete this._cartRequestResolver;

      if (type === 'resolve') {
        resolver.resolve(value);
      } else {
        resolver.abortController?.abort(value);
        resolver.reject(value);
      }
      return true;
    }

    cancelCartRequest() {
      const resolver = this._cartRequestResolver;
      if (!resolver) return;
      clearTimeout(resolver.timeout);
      resolver.settled = true;
      resolver.abortController?.abort();
      delete this._cartRequestResolver;
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      this.settleCartRequest('resolve', responseData);
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      this.settleCartRequest('reject', error);
    }

    async fetchCartState() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) {
        throw new Error(`Cart state request failed with ${response.status}`);
      }
      return response.json();
    }

    requestedVariantId(formData) {
      return String(formData.get('id') || '');
    }

    requestedQuantity(formData) {
      const quantity = Number.parseInt(formData.get('quantity') || '1', 10);
      return Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
    }

    variantQuantity(cart, variantId) {
      if (!cart || !Array.isArray(cart.items) || !variantId) return 0;
      return cart.items.reduce((total, item) => {
        const itemVariantId = String(item.variant_id ?? item.id ?? '');
        const itemQuantity = Number.parseInt(item.quantity, 10) || 0;
        return itemVariantId === variantId ? total + itemQuantity : total;
      }, 0);
    }

    hasRequestedCartDelta(cartBefore, cartAfter, formData) {
      if (!cartBefore || !cartAfter) return false;
      const variantId = this.requestedVariantId(formData);
      const delta = this.variantQuantity(cartAfter, variantId) - this.variantQuantity(cartBefore, variantId);
      return delta >= this.requestedQuantity(formData);
    }

    findRequestedCartItem(cart, formData) {
      if (!cart || !Array.isArray(cart.items)) return null;
      const variantId = this.requestedVariantId(formData);
      return cart.items.find((item) => String(item.variant_id ?? item.id ?? '') === variantId) || null;
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      const form = (e.target.closest && e.target.closest('form')) || (e.target.querySelector && e.target.querySelector('form'));
      if (!form || form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      const form = (e.target.closest && e.target.closest('form')) || (e.target.querySelector && e.target.querySelector('form'));
      if (!form || form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) {
      const form = (e.target.closest && e.target.closest('form')) || (e.target.querySelector && e.target.querySelector('form'));
      if (!form || form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (!(error instanceof Error) && error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      // Move FIRST, before any binding/state capture. moveToBody's
      // appendChild reconnects the element; the _initialized guard above
      // makes that second connectedCallback a no-op.
      this.moveToBody();

      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close(), { signal });
      }
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          try {
            elementToFocus.focus()
          } catch (fallbackError) {
            window.__steedReportError && window.__steedReportError('overlay-drawer:restore-focus', fallbackError);
          }
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();
    // The currently-open lightbox instance (shared keydown dispatch target)
    static openInstance = null;
    // Guard so the document-level keydown listener is registered only once
    static _keydownBound = false;
    static openCount = 0;
    static previousBodyOverflow = null;

    static lockScroll() {
      if (OverlayLightbox.openCount === 0) {
        OverlayLightbox.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
      OverlayLightbox.openCount += 1;
    }

    static unlockScroll() {
      OverlayLightbox.openCount = Math.max(OverlayLightbox.openCount - 1, 0);
      if (OverlayLightbox.openCount === 0) {
        document.body.style.overflow = OverlayLightbox.previousBodyOverflow || '';
        OverlayLightbox.previousBodyOverflow = null;
      }
    }

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;
      this.abortController = null;
      this.previouslyFocused = null;
      this.trapFocusHandlers = {};
      this.trapFocusAbortController = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();

      // Register this instance
      if (this.group) {
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }

      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      const { signal } = this.abortController;

      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        }, { signal });
        this.trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            this.openLightbox();
          }
        }, { signal });
      }

      // Register the document-level keydown listener once for all instances.
      // It dispatches Escape/Arrow handling to the currently-open instance,
      // avoiding N per-instance global handlers on image-heavy galleries.
      if (!OverlayLightbox._keydownBound) {
        OverlayLightbox._keydownBound = true;
        document.addEventListener('keydown', OverlayLightbox.handleGlobalKeydown);
      }
    }

    // Shared document keydown handler: routes Escape/Arrow keys to the open instance
    static handleGlobalKeydown(e) {
      const instance = OverlayLightbox.openInstance;
      if (!instance || !instance.isOpen()) return;

      if (e.key === 'Escape') {
        instance.closeLightbox();
      } else if (instance.group) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          instance.navigateToPrevious();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          instance.navigateToNext();
        }
      }
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }
      if (!this.overlay || this.isOpen()) {
        return;
      }

      // Capture the element to restore focus to when the lightbox closes
      // (after the re-open guard, so a no-op re-open can't clobber it)
      this.previouslyFocused = document.activeElement;

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      OverlayLightbox.lockScroll();

      // Mark this as the active instance for the shared document keydown handler
      OverlayLightbox.openInstance = this;

      // Move focus into the dialog and trap Tab focus within it
      (this.closeBtn || this.overlay).focus();
      this.trapFocus(this.overlay);

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      const { signal } = this.abortController;

      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        }, { signal });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        }, { signal });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        }, { signal });
      }

      // Close lightbox when clicking outside content (D3).
      //
      // This used to require `e.target === this.overlay`, i.e. the click had to
      // land on the backdrop element ITSELF. `.overlay-lightbox__content` fills
      // most of the backdrop, so on mobile — where the image is letterboxed
      // inside a portrait viewport — nearly every "tap outside the picture to
      // dismiss" landed on __content and did nothing. The lightbox looked
      // stuck, and the only way out was the close button.
      //
      // Invert it: dismiss unless the tap actually hit content. Every lightbox
      // slot in this theme is a bare <img> (the gallery only wraps images;
      // video/model media never enter a lightbox), and all three controls are
      // real <button> elements, so `closest()` on this list covers the live
      // surface. video/model-viewer are listed defensively in case a future
      // slot carries them.
      //
      // Residual, accepted: `.overlay-lightbox__content img` is
      // `max-height: 100%; object-fit: contain`, so on a wide-and-short
      // viewport the image letterboxes INSIDE its own <img> box and taps in
      // those transparent bands still will not dismiss. That is not the mobile
      // portrait case this fixes.
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (!e.target.closest('img, video, model-viewer, button')) {
            this.closeLightbox();
          }
        }, { signal });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      // Capture open state before the overlay class is removed
      const wasOpen = this.isOpen();

      // Tear down the focus trap before the overlay is removed
      this.removeTrapFocus();

      // Clear the shared active-instance pointer if this instance owned it
      if (OverlayLightbox.openInstance === this) {
        OverlayLightbox.openInstance = null;
      }

      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');

        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      if (wasOpen) {
        OverlayLightbox.unlockScroll();
      }

      // Restore focus to the element that opened the lightbox
      if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
        this.previouslyFocused.focus();
      }
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];

      // Restore DOCUMENT order (D10). The registry is append-ordered by
      // connectedCallback, so slides hydrated later — thumbnail jumps, or
      // swiping back from slide 0 — land at the end regardless of where they
      // sit in the gallery. Prev/next then jumped to whatever was appended
      // next rather than the visually adjacent image.
      //
      // Sort IN PLACE, deliberately. `this.groupItems` is a live alias of the
      // registry array, and disconnectedCallback splices that array BY IDENTITY
      // to deregister a lightbox. A `[...items].sort()` copy would keep
      // entries that have since been spliced out and whose abortController has
      // already fired, so navigating into one would open an overlay whose
      // close/prev/next listeners are all dead. Sorting the array itself keeps
      // every holder of the alias consistent.
      this.groupItems.sort((a, b) => {
        const position = a.compareDocumentPosition(b);
        if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
        if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
        return 0;
      });

      // Recompute AFTER sorting: currentIndex is a plain integer snapshot, so
      // reading it before the reorder would point at the wrong neighbour.
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        const adjacentItems = [
          this.groupItems[this.currentIndex],
          this.groupItems[(this.currentIndex - 1 + this.groupItems.length) % this.groupItems.length],
          this.groupItems[(this.currentIndex + 1) % this.groupItems.length]
        ].filter((item, index, items) => item && items.indexOf(item) === index);

        adjacentItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url, window.location.href);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        window.__steedReportError && window.__steedReportError('overlay-lightbox:extract-image-size', e);
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl, window.location.href);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        window.__steedReportError && window.__steedReportError('overlay-lightbox:largest-image-url', e);
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Return all focusable elements within a container (ported from overlay.drawer)
    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex;

      element.tabIndex = -1;
      element.dataset.tabIndex = savedTabIndex;
      element.focus();
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className);
      }
      element.addEventListener('blur', callback);

      function callback(event) {
        event.target.removeEventListener(event.type, callback);

        element.tabIndex = savedTabIndex;
        delete element.dataset.tabIndex;
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className);
        }
      }
    }

    // Trap Tab focus within the open dialog (ported from overlay.drawer)
    trapFocus(container, options = {}) {
      let elements = this.focusable(container);
      let first = elements[0];
      let last = elements[elements.length - 1];

      this.removeTrapFocus();

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options);
        }

        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal });
      }.bind(this);

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown);
      }.bind(this);

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return; // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          this.forceFocus(first || container, options);
        }

        // On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          this.forceFocus(last || container, options);
        }
      }.bind(this);

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal });
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal });
    }

    removeTrapFocus() {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.isOpen()) {
        this.closeLightbox();
      }

      if (this.abortController) {
        this.abortController.abort();
      }

      this.removeTrapFocus();

      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      this.requestGeneration = 0;
      this.selectionAbortController = null;
      this.prefetchAbortController = new AbortController();
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    connectedCallback() {
      if (!this.prefetchAbortController || this.prefetchAbortController.signal.aborted) {
        this.prefetchAbortController = new AbortController();
      }
    }

    disconnectedCallback() {
      this.requestGeneration += 1;
      this.selectionAbortController?.abort();
      this.selectionAbortController = null;
      this.prefetchAbortController?.abort();
      this.activeRequests.clear();
      this.hideLoadingState();
    }

    showLoadingState(generation) {
      this.hideLoadingState();
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        if (generation === this.requestGeneration) {
          this.classList.add('product-hot-reload--loading');
        }
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Ticket #33: walk EVERY radio in DOM order, not just the checked ones.
      // When building a hover URL we substitute the hovered value for that
      // option group's current selection IN PLACE, so the prefetched URL is
      // byte-identical to the URL the following click requests (the prefetch
      // cache is keyed on the exact URL string). On the click path the input is
      // already checked, so hoverOptionName is null and this emits exactly what
      // the old :checked pass emitted, in the same order.
      const hoverOptionName = input.type === 'radio' && !input.checked ? input.name : null;
      let hoverOptionApplied = false;
      Array.from(productFormElement.querySelectorAll('input[type="radio"]')).forEach((radio) => {
        if (hoverOptionName && radio.name === hoverOptionName) {
          if (!hoverOptionApplied && optionValueId) {
            selectedOptionValues.push(optionValueId);
            hoverOptionApplied = true;
          }
          return;
        }
        if (radio.checked && radio.dataset.optionValueId) {
          selectedOptionValues.push(radio.dataset.optionValueId);
        }
      });
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      const requestUrl = new URL(newProductUrl || this.dataset.productUrl || window.location.pathname, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);
      if (selectedOptionValues.length > 0) {
        requestUrl.searchParams.set('option_values', selectedOptionValues.join(','));
      }

      return this.preservePreviewContext(requestUrl);
    }

    preservePreviewContext(url) {
      if (window.theme && window.theme.utils && window.theme.utils.preservePreviewParams) {
        return window.theme.utils.preservePreviewParams(url);
      }

      const outputUrl = new URL(url, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      ['preview_theme_id', 'preview_token', '_cd', '_uid', 'pb'].forEach((param) => {
        const value = currentParams.get(param);
        if (value) {
          outputUrl.searchParams.set(param, value);
        }
      });

      return outputUrl.toString();
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl, { signal: this.prefetchAbortController.signal }).catch((error) => {
        if (error.name === 'AbortError') return;
        window.__steedReportError && window.__steedReportError('product-hot-reload:prefetch', error);
      });
    }

    fetchContent(requestUrl, options = {}) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl, { signal: options.signal })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Product hot reload request failed: ${response.status}`);
          }
          return response.text();
        })
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          if (this.cache.size > 15) {
            this.cache.delete(this.cache.keys().next().value);
          }
          return html;
        })
        .finally(() => {
          if (this.activeRequests.get(requestUrl) === fetchPromise) {
            this.activeRequests.delete(requestUrl);
          }
        });

      if (options.track !== false) {
        this.activeRequests.set(requestUrl, fetchPromise);
      }
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      const generation = this.requestGeneration + 1;
      this.requestGeneration = generation;
      this.selectionAbortController?.abort();
      this.selectionAbortController = new AbortController();
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState(generation);

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl, { signal: this.selectionAbortController.signal, track: false });
        }

        if (generation !== this.requestGeneration) return;
        await this.updateProductWithTransition(html, newProductUrl, event.target.id, generation);
      } catch (error) {
        if (error.name === 'AbortError' || generation !== this.requestGeneration) return;
        window.__steedReportError && window.__steedReportError('product-hot-reload:update', error, { severity: 'error' });
      } finally {
        if (generation === this.requestGeneration) {
          this.selectionAbortController = null;
          this.hideLoadingState();
        }
      }
    }

    captureGalleryState() {
      const gallery = this.querySelector('media-gallery');
      if (!gallery || !gallery.slides) return null;
      // Read the index the gallery tracks rather than querying for the active
      // class: during a slide animation two slides carry --active for ~300ms,
      // so a DOM query would return the slide the shopper just left.
      const activeSlide = gallery.slides[gallery.currentIndex];
      return {
        mediaId: activeSlide ? activeSlide.dataset.mediaId || '' : '',
        variantMediaId: gallery.dataset.variantMediaId || ''
      };
    }

    applyUpdatedContent(updatedHtml, galleryState) {
      this.innerHTML = updatedHtml.innerHTML;
      this.dataset.productUrl = updatedHtml.dataset.productUrl;
      this.dataset.variantId = updatedHtml.dataset.variantId;
      this.restoreGalleryState(galleryState);
    }

    restoreGalleryState(state) {
      if (!state || !state.mediaId) return;
      const gallery = this.querySelector('media-gallery');
      if (!gallery || typeof gallery.showMediaById !== 'function') return;
      // Picking a variant that owns its OWN featured media SHOULD jump to that
      // media, so suppress the restore only when the freshly rendered gallery
      // really has a variant-featured media and it is a different one. The
      // attribute is "0" when the variant has no featured media, in which case
      // there is nothing to jump to and the shopper keeps their place.
      const variantMediaId = gallery.dataset.variantMediaId || '';
      if (variantMediaId && variantMediaId !== '0' && variantMediaId !== state.variantMediaId) return;
      gallery.showMediaById(state.mediaId);
    }

    async updateProductWithTransition(html, newProductUrl, targetId, generation) {
      const updatedHtml = html.getElementById(this.id);
      if (!updatedHtml) {
        throw new Error('Product hot reload response missing updated product content');
      }
      if (generation !== this.requestGeneration) return;
      
      // Ticket #10: remember where the shopper had browsed to before the swap.
      const galleryState = this.captureGalleryState();

      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          if (generation !== this.requestGeneration) return;
          this.applyUpdatedContent(updatedHtml, galleryState);
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.applyUpdatedContent(updatedHtml, galleryState);
      }

      if (generation !== this.requestGeneration) return;

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      const focusTarget = targetId && this.querySelector(`#${CSS.escape(targetId)}`);
      if (focusTarget) focusTarget.focus();

      // Ticket 6 (pdp-variant-price-change-not-announced): this swap rewrites the
      // price with no event of any kind, so nothing downstream can announce it.
      // Emit one bubbling signal once the new subtree is live and focus has
      // settled; the sitewide role=status announcer in
      // snippets/brand-a11y-shims.liquid debounces it and reads the rendered
      // price back out of the DOM. Only reached on a current, non-aborted
      // generation, so stale/aborted fetches stay silent.
      this.dispatchEvent(new CustomEvent('variant:rendered', {
        bubbles: true,
        detail: { variantId: this.dataset.variantId, productUrl: this.dataset.productUrl }
      }));
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', (event) => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          const error = event.detail.error
          this.displayErrorMessage(event.detail.error)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of [this.emailInput, this.nameInput, this.messageInput, this.dateInput]) {
        if (element) element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (!body) return

      const genericError = this.querySelector('[data-gift-recipient-generic-error]')
      const displayGenericError = (message) => {
        if (!genericError) return
        genericError.textContent = message || genericError.dataset.defaultMessage || 'Gift recipient details could not be saved. Check the fields and try again.'
        genericError.hidden = false
      }

      // Field-keyed object: { email: '...', name: '...', message: '...', date: '...' }
      if (typeof body === 'object' && !Array.isArray(body)) {
        let matchedInput = false
        Object.entries(body).forEach(([key]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) return
          inputElement.setAttribute('aria-invalid', true)
          matchedInput = true
        })
        if (!matchedInput) displayGenericError(body.message || body.description)
        return
      }

      // String/array errors are not field-keyed; show the generic message and
      // flag the required email field so assistive tech announces a problem.
      if (this.emailInput) {
        this.emailInput.setAttribute('aria-invalid', true)
      }
      displayGenericError(Array.isArray(body) ? body.join(', ') : body)
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
      const genericError = this.querySelector('[data-gift-recipient-generic-error]')
      if (genericError) {
        genericError.textContent = ''
        genericError.hidden = true
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      // Interaction queued while a slide transition is in flight; null means none.
      this.pendingIndex = null;
      this.pendingDirection = null;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.touchGestureActive = false;
      // 18px, not 30: browsers suppress the click after ~10px of touch
      // movement, so drags in the old 10-30px band produced NO response at all
      // (a measured dead-click source — 2026-08-19 review U1). 18px clears
      // normal touch slop while closing most of that dead band; the
      // absDeltaX > absDeltaY guard in handleTouchEnd keeps vertical scrolls
      // from advancing slides. Revert this line alone if advancing feels jumpy
      // on real devices.
      this.minSwipeDistance = 18;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      this.mutationObservers = new Set();
      this.init();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      this.mutationObservers?.forEach((o) => o.disconnect());
      this.mutationObservers?.clear();
      this.pendingIndex = null;
      this.pendingDirection = null;
      this.initialized = false;
    }

    init() {
      this.hydrateSlide(this.slides[this.currentIndex]);

      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        }, { signal: this.abortController.signal });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        }, { signal: this.abortController.signal });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        }, { signal: this.abortController.signal });
      }

      // Roving tabindex: the thumbnail strip is a single tab stop
      this.rovingIndex = this.currentIndex;
      this.setThumbTabStop(this.currentIndex);

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (this.handleThumbKeydown(e)) return;
        // Auto-repeat must not queue intents: a held arrow would accumulate one
        // per repeat and scrub the gallery. Keep the pre-queue throttle of one
        // slide per settled transition for repeats only.
        if (e.repeat && this.isAnimating) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      }, { signal: this.abortController.signal });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers (D9).
      //
      // Bound to `.media-gallery__main`, NOT the host. The thumbnail rail is a
      // SIBLING of the main stage inside the host, so host-level touch
      // listeners also saw every drag of the rail and interpreted a horizontal
      // scroll of the thumbnails as a swipe of the main image. On a 72%-mobile
      // store that means scrolling the thumbnails silently changed the slide
      // underneath.
      //
      // Keydown deliberately stays on the host, which carries tabindex="0"
      // (set just above), so keyboard navigation still works when focus is on
      // the gallery as a whole.
      //
      // Same abortController signal, so disconnectedCallback still detaches
      // these in one place.
      const touchTarget = this.mainContainer || this;
      touchTarget.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true, signal: this.abortController.signal });
      touchTarget.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true, signal: this.abortController.signal });
      touchTarget.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true, signal: this.abortController.signal });
      touchTarget.addEventListener('touchcancel', this.resetTouchGesture.bind(this), { passive: true, signal: this.abortController.signal });

      this.addEventListener('click', (event) => {
        if (event.target.closest('.overlay-lightbox__trigger')) {
          this.hydrateAllSlides();
        }
      }, { capture: true, signal: this.abortController.signal });

      this.addEventListener('keydown', (event) => {
        if ((event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') && event.target.closest('.overlay-lightbox__trigger')) {
          this.hydrateAllSlides();
        }
      }, { capture: true, signal: this.abortController.signal });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (this.isAnimating) {
        // Queue the latest intent instead of dropping the tap; it is applied
        // when the in-flight transition settles (see flushPendingSlide).
        if (index === this.currentIndex) {
          this.pendingIndex = null;
          this.pendingDirection = null;
        } else {
          this.pendingIndex = index;
          this.pendingDirection = direction;
        }
        return;
      }
      if (index === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];
      this.hydrateSlide(targetSlide);

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex]?.classList.remove('media-gallery__thumb--active');
      this.thumbs[this.currentIndex]?.setAttribute('aria-current', 'false');
      this.thumbs[activeIndex]?.classList.add('media-gallery__thumb--active');
      this.thumbs[activeIndex]?.setAttribute('aria-current', 'true');
      this.setThumbTabStop(activeIndex);
    }

    setThumbTabStop(index) {
      if (!this.thumbs.length) return;
      const target = Math.min(Math.max(index, 0), this.thumbs.length - 1);
      this.thumbs[this.rovingIndex]?.setAttribute('tabindex', '-1');
      this.thumbs[target].setAttribute('tabindex', '0');
      this.rovingIndex = target;
    }

    handleThumbKeydown(e) {
      const thumb = e.target.closest('.media-gallery__thumb');
      if (!thumb) return false;
      const count = this.thumbs.length;
      const current = Array.prototype.indexOf.call(this.thumbs, thumb);
      if (current < 0) return false;

      let next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = (current + 1) % count;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = (current - 1 + count) % count;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = count - 1;
      }
      if (next === null) return false;

      e.preventDefault();
      this.setThumbTabStop(next);
      this.thumbs[next].focus();
      return true;
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;
      if (activeSlide.getAttribute('data-media-type') && activeSlide.getAttribute('data-media-type') !== 'image') {
        this.mainContainer.style.height = '';
        return;
      }

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      this.slides.forEach((slide) => this.observeSlideImages(slide));
    }

    observeSlideImages(slide) {
      if (!this.resizeObserver || !slide || slide.getAttribute('data-media-type') !== 'image') return;

      slide.querySelectorAll('img').forEach((img) => {
        if (img.dataset.galleryResizeObserved) return;
        img.dataset.galleryResizeObserved = 'true';
        this.resizeObserver.observe(img);
        img.addEventListener('load', () => {
          if (slide.classList.contains('media-gallery__slide--active')) {
            this.adjustContainerHeight();
          }
        }, { signal: this.abortController.signal });
      });
    }

    hydrateSlide(slide) {
      if (!slide || !slide.hasAttribute('data-media-deferred')) return slide;

      const template = slide.querySelector(':scope > template[data-media-template]');
      if (!template) return slide;

      slide.appendChild(template.content.cloneNode(true));
      template.remove();
      slide.removeAttribute('data-media-deferred');
      this.observeSlideImages(slide);
      return slide;
    }

    hydrateAllSlides() {
      this.slides.forEach((slide) => this.hydrateSlide(slide));
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            if (this.pendingIndex === null) this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
            // Apply any tap or swipe that arrived during the animation window.
            this.flushPendingSlide();
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    showMediaById(mediaId) {
      if (!mediaId) return false;
      const target = String(mediaId);
      let index = -1;
      this.slides.forEach((slide, slideIndex) => {
        if (index === -1 && slide.dataset.mediaId === target) index = slideIndex;
      });
      if (index === -1) return false;
      if (index === this.currentIndex) return true;

      // Instant jump, no animation: this runs inside the hot-reload view
      // transition callback, where goToSlide would snapshot the target slide
      // still parked off-screen and animate it in only afterwards.
      const previousSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];
      this.hydrateSlide(targetSlide);
      this.resetSlides();
      this.slides.forEach((slide) => {
        slide.classList.remove('media-gallery__slide--is-animating');
        slide.style.transform = '';
      });
      previousSlide?.classList.remove('media-gallery__slide--active');
      targetSlide.classList.add('media-gallery__slide--active');
      // Called before currentIndex moves: updateThumbnails clears the OLD index.
      this.updateThumbnails(index);
      this.currentIndex = index;
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
      if (this.isNaturalAspectRatio) this.adjustContainerHeight(true);
      return true;
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex]?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    // Index the user has asked for, including intents queued mid-animation.
    intentIndex() {
      return this.pendingIndex === null ? this.currentIndex : this.pendingIndex;
    }

    flushPendingSlide() {
      if (this.pendingIndex === null) return;
      const index = this.pendingIndex;
      const direction = this.pendingDirection || 'next';
      this.pendingIndex = null;
      this.pendingDirection = null;
      this.goToSlide(index, direction);
    }

    nextSlide() {
      const nextIndex = (this.intentIndex() + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const from = this.intentIndex();
      const prevIndex = from === 0 ? this.slides.length - 1 : from - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        let settled = false;
        let timeoutId = null;
        const finish = () => {
          if (settled) return;
          settled = true;
          if (timeoutId !== null) window.clearTimeout(timeoutId);
          element.removeEventListener('transitionend', handleTransitionComplete);
          element.removeEventListener('transitioncancel', handleTransitionComplete);
          resolve();
        };
        const handleTransitionComplete = (event) => {
          if (event.target === element) finish();
        };
        const parseTimes = (value) => value.split(',').map((part) => {
          const time = part.trim();
          if (time.endsWith('ms')) return Number.parseFloat(time) || 0;
          if (time.endsWith('s')) return (Number.parseFloat(time) || 0) * 1000;
          return 0;
        });
        const styles = window.getComputedStyle(element);
        const durations = parseTimes(styles.transitionDuration || '0s');
        const delays = parseTimes(styles.transitionDelay || '0s');
        const transitionTime = durations.reduce((longest, duration, index) => {
          return Math.max(longest, duration + delays[index % delays.length]);
        }, 0);

        element.addEventListener('transitionend', handleTransitionComplete);
        element.addEventListener('transitioncancel', handleTransitionComplete);
        timeoutId = window.setTimeout(finish, Math.max(50, transitionTime + 50));

        // Browsers do not emit transition events when duration is zero (for
        // example under reduced motion), so settle on the next painted frame.
        if (transitionTime === 0) window.requestAnimationFrame(finish);
      });
    }

    handleTouchStart(e) {
      // Track the gesture even mid-animation; handleTouchEnd queues the intent.
      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
      this.touchGestureActive = true;
    }

    handleTouchMove(e) {
      if (!this.touchGestureActive) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (!this.touchGestureActive) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX >= this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
      this.resetTouchGesture();
    }

    resetTouchGesture() {
      this.touchGestureActive = false;
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                this.mutationObservers.delete(observer);
                element.play();
                break;
              }
            }
          });

          this.mutationObservers.add(observer);
          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element once; section re-renders can execute this bundle again.
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGalleryElement);
  }
  } catch(e) { console.error(e); }
})();

})();
